import script from "./SelectableBreakdownText.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectableBreakdownText.vue?vue&type=script&setup=true&lang=js"

import "./SelectableBreakdownText.vue?vue&type=style&index=0&id=37729cec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37729cec"]])

export default __exports__